import { Trash2 } from 'lucide-react';

export default function DeleteConfirmModal({ 
  show, 
  deletingMethod, 
  onConfirm, 
  onCancel 
}) {
  console.log('DeleteConfirmModal render - show:', show, 'deletingMethod:', deletingMethod);
  if (!show || !deletingMethod) return null;

  return (
    <div className="flex fixed inset-0 z-[9999] justify-center items-center p-4 bg-black bg-opacity-50">
      <div className="overflow-hidden mx-4 w-full max-w-md bg-white rounded-2xl shadow-2xl">
        <div className="p-6 text-center">
          <div className="flex justify-center items-center mx-auto mb-6 w-20 h-20 bg-red-100 rounded-full">
            <Trash2 size={32} className="text-red-600" />
          </div>
          <h3 className="mb-2 text-xl font-semibold text-gray-900">Delete Payment Method</h3>
          <p className="mb-6 text-gray-600">
            Are you sure you want to delete <strong>{deletingMethod.provider}</strong>? This action cannot be undone.
          </p>
          
          {deletingMethod.isDefault && (
            <div className="p-3 mb-6 bg-amber-50 rounded-lg border border-amber-200">
              <p className="text-xs text-amber-700">
                <strong>Note:</strong> This is your default payment method. Deleting it will remove the default status.
              </p>
            </div>
          )}

          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 rounded-lg transition-colors hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-4 py-3 font-medium text-white bg-red-600 rounded-lg transition-colors hover:bg-red-700"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
